import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#d4216c',
                secondary: '#7b2c88',
                accent: '#8bc34a',
                error: '#871643',
                warning: '#ff5722',
                info: '#00bcd4',
                success: '#4caf50',
            },
        },
    },
});
